<script setup lang="ts">
/**
 * LoadingSpinner - Full-page transparent overlay loading indicator
 *
 * Always shows a centered spinner with description text over a semi-transparent backdrop.
 * Use for all loading states: initial load, refresh, form submission, etc.
 */
import { useI18n } from 'vue-i18n'
import { Loader2 } from 'lucide-vue-next'

const props = withDefaults(defineProps<{
  text?: string
}>(), {})

const { t } = useI18n()
</script>

<template>
  <div class="fixed inset-0 bg-white/70 dark:bg-gray-900/70 backdrop-blur-sm flex items-center justify-center z-50">
    <div class="flex flex-col items-center gap-4">
      <Loader2 :size="40" class="text-blue-600 dark:text-blue-400 animate-spin" />
      <p class="text-gray-700 dark:text-gray-300 font-medium">{{ props.text || t('loading') }}</p>
    </div>
  </div>
</template>
